export function isGenericPersonaCatalogCategory(
  category: string | null | undefined,
) {
  return category?.trim() === "Sample Personas"
}
